import { formatForm } from './form';
import { formatMarkTask } from './task';

export const form = {
  create: (name) => ({
    method: 'POST',
    url: '{{backendUrl}}/v1_0/form/post',
    parse: 'parseForm',
    json: { Json: JSON.stringify({ name }) },
  }),
  get: (formId) => ({
    method: 'GET',
    url: `{{backendUrl}}/v1_0/form/get?IdForm=${formId}`,
    parse: 'parseForm',
  }),
  update: (values) => ({
    method: 'PUT',
    url: '{{backendUrl}}/v1_0/form/post',
    parse: 'parseForm',
    json: formatForm(values),
  }),
};

export const task = {
  getTask: (projectId, isReview) => ({
    method: 'POST',
    url: '{{taskUrl}}/v1_0/Task',
    parse: 'parseTask',
    json: {
      IdProject: parseInt(projectId, 10),
      isReview,
    },
  }),
  getForm: (formId) => ({
    method: 'GET',
    url: `{{taskUrl}}/v1_0/form/get?IdForm=${formId}`,
    parse: 'parseForm',
  }),
  createAnswer: (taskId, supportDateTime, duration, answer) => ({
    method: 'PUT',
    url: '{{taskUrl}}/v1_0/task',
    json: {
      IdTask: taskId,
      SupportDateTime: supportDateTime,
      Duration: duration,
      JsonAnswer: JSON.stringify(answer),
    },
  }),
  updateMark: (values) => ({
    method: 'POST',
    url: '{{taskUrl}}/v1_0/Mark',
    json: formatMarkTask(values),
  }),
  release: (taskId) => ({
    method: 'DELETE',
    url: `{{taskUrl}}/v1_0/Task?IdTask=${taskId}`,
  }),
  keep: (taskId) => ({
    method: 'PATCH',
    url: `{{taskUrl}}/v1_0/Task?IdTask=${taskId}`,
  }),
};

// v3 only allows to view task answers, so "answerOf" is ignored here.
export const answer = {
  get: (answerOf, params) => ({
    method: 'GET',
    url: `{{taskUrl}}/v1_0/task?IdTask=${params.taskId}`,
    parse: 'parseAnswer',
  }),
};

export const certification = {
  get: (certificationId) => ({
    method: 'POST',
    url: '{{certificationUrl}}/v1_0/Certification',
    parse: 'parseCertification',
    json: {
      IdCertification: parseInt(certificationId, 10),
    },
  }),
  getForm: (formId) => ({
    method: 'GET',
    url: `{{certificationUrl}}/v1_0/form/get?IdForm=${formId}`,
    parse: 'parseForm',
  }),
  createAnswer: (
    certificationId,
    certificationUserId,
    certificationQuestionId,
    certificationUserQuestionId,
    answer,
  ) => ({
    method: 'PUT',
    url: '{{certificationUrl}}/v1_0/certification',
    json: {
      IdCertification: certificationId,
      IdCertificationUser: certificationUserId,
      IdCertificationQuestion: certificationQuestionId,
      IdCertificationUserQuestion: certificationUserQuestionId,
      JsonAnswer: JSON.stringify(answer),
    },
  }),
};
